// extracted by mini-css-extract-plugin
module.exports = {"notificationAlertsRoot":"KTHGO1Vr"};